import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import MUIDataTable from "mui-datatables";
import {
  Card,
  CardContent,
  Container,
  Grid,
  IconButton,
  Skeleton,
  ThemeProvider,
  Tooltip,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { fShortenNumber } from "../../../../Utils/formatNumber";

import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import Iconify from "../../../../Components/Dashboard/Iconify";
import Page from "../../../../Components/Dashboard/Page";

import {
  ViewIcon,
  EditIcon,
  ActivateIcon,
  DeactivateIcon,
  MuiDataTableTheme,
  ColumnTextStyle,
} from "../../../../Components/MuiDataTableTheme/MuiDataTableTheme";
import {
  components,
  PrintButtonIcon,
} from "../../../../Components/Icons/DataTableIcons";
import { ElevatedGreenButton } from "../../../../Components/Button/CustomButton";
import { poppinsCustomTheme } from "../../../../Styles/GlobalStyles/PoppinsTheme";
import { CreateCentreDialog } from "../../../../Components/Acquisition/CustomDialogs";
import ConfirmDialog from "../../../../Components/Alert/ConfirmDialog";
import { colors } from "../../../../Styles/GlobalStyles/Variables";
import LoadingOverlay from "react-loading-overlay-ts";
import StatusGenerator from "../../../../Components/StatusGenerator/StatusGenerator";

import {
  restoreSkillAcquisitionCentreInitial,
  fetchTotalSkillCenterDetails,
  fetchAllSkillCentres,
  createSkillCentre,
  activateSkillCentre,
  deactivateSkillCentre,
  editSkillCentre,
  fetchStates,
  fetchSkillSelect,
  makeRequest,
  // printSkillAcquisition,
  exportSkillAcquisition,
  fetchSkillCenterSelect,
  emptySkillCenterSelect,
} from "../../../../Actions";
import { Paper } from "@mui/material";
import ArchiveIcon from "@mui/icons-material/Archive";
import Searchbox from "../../../../Components/Dashboard/Searchbox";
import { Box } from "@mui/material";
import { clearMsg, infoMsg } from "../../../../Utils/apiToasts";
import AcquisitionPrintTemplate from "../../../../Components/PrintFiles/AcquisitionPrintTemplate";

import FilterButton from "../../../../Components/Button/FilterButton";

LoadingOverlay.propTypes = undefined;

const MyViewIcon = ({ tip, onClickHandler }) => {
  return (
    <Tooltip title={tip}>
      <IconButton size="small" onClick={onClickHandler}>
        <ViewIcon icon="material-symbols:visibility-outline" />
      </IconButton>
    </Tooltip>
  );
};

const MyEditIcon = ({ tip, onClickHandler }) => {
  return (
    <Tooltip title={tip}>
      <IconButton size="small" onClick={onClickHandler}>
        <EditIcon icon="icon-park-outline:edit" />
      </IconButton>
    </Tooltip>
  );
};

const RootStyle = styled(Card)(({ theme, bgColor = "#FFE2E5", isLoading }) => ({
  boxShadow: "none",
  textAlign: "center",
  padding: theme.spacing(3, 0),
  color: theme.palette.primary.darker,
  backgroundColor: bgColor,
  minWidth: "230px",
  minHeight: "100px",
  borderRadius: "16px",
}));

const IconWrapperStyle = styled("div")(({ theme, bgColor = "#FA5A7D" }) => ({
  margin: "auto",
  display: "flex",
  borderRadius: "50%",
  alignItems: "center",
  width: theme.spacing(5),
  height: theme.spacing(5),
  justifyContent: "center",
  marginBottom: theme.spacing(2),
  color: "#fff",
  backgroundColor: bgColor,
}));

const CardTotalSkills = ({ value, title, bgColor, iconColor, isLoading }) => {
  return (
    <RootStyle bgColor={bgColor}>
      <IconWrapperStyle bgColor={iconColor}>
        <Iconify
          rotate="180deg"
          icon="ant-design:project-filled"
          width={22}
          height={22}
        />
      </IconWrapperStyle>
      {isLoading === false ? (
        <Typography variant="h5" fontWeight={700} fontSize={"25px"}>
          {fShortenNumber(value)}
        </Typography>
      ) : (
        ""
      )}
      <Typography variant="subtitle2" sx={{ opacity: 0.72, fontSize: "12px" }}>
        {title}
      </Typography>
    </RootStyle>
  );
};

const SkillAcquisitionCentre = () => {
  const dispatch = useDispatch();

  const acquisitionState = (state) => state.acquisitionReducer;
  const statesNG = (state) => state.statesReducer;
  const skillSet = (state) => state.skillSelectReducer;

  const { statesfetched } = useSelector(statesNG);
  const { skillSelectFetched } = useSelector(skillSet);
  const {
    allCentres,
    ascTotalLevelData,
    tablePaginationData,
    fetchingDataGeneral,
    makingRequest,
    skillCenterSelectFetched,
    isFetched,
  } = useSelector(acquisitionState);

  const figureColumnStyle = {
    paddingRight: "90px",
    fontSize: "14px",
    fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
  };

  const initialFormState = {
    nameError:false,
    nameErrorMsg: "",
    stateIdError:false,
    stateIdErrorMsg: "",
    skillIdsError:false,
    skillIdsErrorMsg: "",
  };
  const [showPrintPreview, setShowPrintPreview] = useState(false);
  const [acquisitionDialogIsOpen, setAcquisitionDialogIsOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [dialogMode, setDialogMode] = useState(""); // Create || Edit || View
  const [editCenterId, setEditCenterId] = useState(0);
  const [centresTableData, setCentresTableData] = useState([]);
  const [allStatesNG, setAllStatesNG] = useState([]);
  const [skillSelect, setSkillSelect] = useState([]);
  const [filterOptions, setFilterOptions] = useState("[]");
  const [filters, setFilters] = useState("[]");
  const [formStates, setFormStates] = useState(initialFormState);
  const [actionWatcher, setActionWatcher] = useState(false);
  const [tablePageData, setTablePageData] = useState({
    pageNumber: 1,
    pageSize: 10,
    Search: searchText,
    filterOptions: filterOptions,
  });
  const [newCentreData, setNewCentreData] = useState({
    // dialog data used for API purposes
    name: "",
    stateId: null,
    skillIds: [],
  });
  const [dialogStateData, setDialogStateData] = useState({
    // state controller for autocomplete state field
    // Ex: {label: Abia, value: 2}
    label: "",
    value: null,
  });
  const [dialogSkillData, setDialogSkillData] = useState([
    {
      // state controller for autocomplete skill field
      // Ex: {label: ICT, value: 2}
      label: "",
      value: null,
    },
  ]);

  const [dashboardValues, setDashboardValues] = useState({
    allCentres: 0,
    activeCentres: 0,
    inactiveCentres: 0,
    pcActivities: 0,
  });

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
    header: "",
    backgroundColor: "",
    borderSideColor: "",
    color: "",
    subColor: "",
  });

  // helper functions
  const printIdCardArea = () => {
    var iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.srcdoc = document.getElementById("printarea").innerHTML;
    document.body.appendChild(iframe);
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    iframe.contentWindow.close();
    iframe.style.display = "none";
    clearMsg();
  };

  const fireApi = () => {
    return dispatch(fetchSkillCenterSelect());
  };

  const printSkillCenterPdf = async () => {
    await fireApi();
    infoMsg("Loading the print preview window...");
    setShowPrintPreview(true);
  };

  const openAcquisitionDialog = (mode, centreId = 0) => {
    setAcquisitionDialogIsOpen(true);
    setDialogMode(mode);

    if (statesfetched.length < 1) {
      dispatch(fetchStates());
    }
    if (skillSelectFetched.length < 1) {
      dispatch(fetchSkillSelect());
    }
  };

  const handleChange = (e) => {
    let searchValue = e.target.value;
    setSearchText(searchValue);
  };

  const handleFilterClick = (event) => {
    if(event !== 0){
      setFilterOptions(event);
      setActionWatcher(true)
      setFilters(event);
    }
  };

  const handleReset = (event) => {
    if(filterOptions !== ""){
      setFilterOptions("");
      setActionWatcher(true)
      setFilters("");
    }
  };

  const closeCreateSkillCentreDialog = () => {
    setAcquisitionDialogIsOpen(false);
    setNewCentreData({
      name: "",
      stateId: 0,
      skillIds: [],
    });
    setDialogStateData({
      label: "",
      value: null,
    });
    setDialogSkillData([
      {
        label: "",
        value: null,
      },
    ]);
    setFormStates({...initialFormState})
  };
    const filterOption = [
    {
      type: "zoneAutocomplete",
      name: "zones",
      group: "Select Zones",
      options: [
        {
          label: "All",
          value: 0,
        },
        {
          label: "North Central",
          value: 1,
        },
        {
          label: "North East",
          value: 2,
        },
        {
          label: "North West",
          value: 3,
        },
        {
          label: "South East",
          value: 4,
        },
        {
          label: "South South",
          value: 5,
        },
        {
          label: "South West",
          value: 6,
        },
      ],
    },
    {
      type: "autocomplete",
      name: "states",
      group: "Select States",
      options: [
      
      ],
    },
    {
      type: "radio",
      name:'status',
      group: "Status",
      options: [
        {
          label: "All",
          value: "",
        },
        {
          label: "Active",
          value: true,
        },
        {
          label: "Inactive",
          value: false,
        },
      ],
    },
  ];


  const createNewCenter = () => {
    if(newCentreData.name === "" || newCentreData.stateId === 0 || (newCentreData.skillIds).length ===0){
      setFormStates({
        ...formStates,
        nameError: newCentreData.name === "",
        nameErrorMsg: "Centre name is required",
        stateIdError: newCentreData.stateId === 0,
        stateIdErrorMsg: "State field is required",
        skillIdsError: (newCentreData.skillIds).length ===0,
        skillIdsErrorMsg: "Skill field is required",

      });
    }
    if(newCentreData.name!=="" && newCentreData.stateId!==0&& (newCentreData.skillIds).length !==0){
      dispatch(createSkillCentre(newCentreData));
      dispatch(makeRequest());
    }  
  };

  const viewCenter = () => {
    // const data = {
    //   name: newCentreData.name,
    //   stateId: dialogStateData.value,
    //   skillIds: dialogSkillData.value,
    // skillcenterid: Number.parseInt(editCenterId),
    // };
    dispatch(makeRequest());
  };

  const editCenter = () => {
    // edit handler

    const editedSkillData = [];
    for (let i = 0; i < dialogSkillData.length; i++) {
      editedSkillData.push(dialogSkillData[i].value);
      setDialogSkillData([{
        ...dialogSkillData,
        value: editedSkillData,
      }])
    }
    const data = {
      name: newCentreData.name,
      stateId: dialogStateData.value,
      skillcenterid: Number.parseInt(editCenterId),
      skillIds: editedSkillData,
    };

    dispatch(editSkillCentre(data));
    dispatch(makeRequest());
    console.log("to edit something here");
  };

  const activateCentre = (id) => {
    dispatch(activateSkillCentre(id));
    dispatch(makeRequest());
  };

  const deactivateCentre = (id) => {
    dispatch(deactivateSkillCentre(id));
    dispatch(makeRequest());
  };

  const fireFetchAllSkillsCentresAPI = () => {
    let params ={}
    params={
      PageNumber: tablePageData.pageNumber,
      PageSize: tablePageData.pageSize,
      Search: searchText,
    }
    if(filterOptions.status !=="" && filterOptions.status !==undefined){
      params['FilterOptions.Status'] = filterOptions.status;
    }
    if(filterOptions.sourceoffunds !=="" && filterOptions.sourceoffunds !==undefined){
      params['FilterOptions.SourceOfFunds'] = filterOptions.sourceoffunds;
    }
    
    if(filterOptions.zones !=="" && filterOptions.zones !==0 &&  filterOptions.zones !==undefined ){
      params['FilterOptions.Zone'] = filterOptions.zones;
    }else {
      delete params['FilterOptions.Zone'] ;
    }

    if(filterOptions.states !=="" && filterOptions.states !==0 &&  filterOptions.states !==undefined ){
      params['FilterOptions.State'] = filterOptions.states;
    }else {
      delete params['FilterOptions.State'] ;
    }
  
    dispatch(
      fetchAllSkillCentres(params)
    );
    dispatch(fetchTotalSkillCenterDetails());
  };


  // use effects
  useEffect(() => {
    fireFetchAllSkillsCentresAPI();
}, [searchText, filters,filterOptions]);

  useEffect(() => {
    fireFetchAllSkillsCentresAPI();
  }, []);

  useEffect(() => {
    if (allCentres.length > 0) {
      let tempTableData = [];

      allCentres.map((centre) => {
        // 1. populate table data
        let centreData = [
          centre.name,
          centre.state,
          centre.skills, // array of objects
          centre.isActive === true ? 1 : 0,
          `${centre.isActive === true ? 1 : 0} ${centre.id}`,
        ];
        tempTableData.push(centreData);
      });

      setCentresTableData(tempTableData);
      setActionWatcher(false)

      // set pagination data for datatable
      if (Object.keys(tablePaginationData).length > 0) {
        setTablePageData(tablePaginationData);
      }

      if (Object.keys(ascTotalLevelData).length > 0) {
        setDashboardValues({
          ...dashboardValues,
          allCentres: ascTotalLevelData.totalSkillCenters,
          activeCentres: ascTotalLevelData.activeSkillCenters,
          inactiveCentres: ascTotalLevelData.inActiveSkillCenters,
        });
      }
    } else {
      setCentresTableData([]);
    }

    return () => {
      dispatch(restoreSkillAcquisitionCentreInitial());
    };
  }, [allCentres, tablePaginationData, ascTotalLevelData]);

  useEffect(() => {
    if (statesfetched.length > 0) {
      let statesModel = [];

      statesfetched.map((state) => {
        statesModel.push({
          label: state.stateName,
          value: state.stateId,
        });
      });

      setAllStatesNG(statesModel);
    }
  }, [statesfetched]);

  useEffect(() => {
    if (skillSelectFetched.length > 0) {
      let skillsModel = [];

      skillSelectFetched.map((state) => {
        skillsModel.push({
          label: state.name,
          value: state.id,
        });
      });

      setSkillSelect(skillsModel);
    }
  }, [skillSelectFetched]);

  useEffect(() => {
    if (makingRequest === false) {
      // if request is completed
      setConfirmDialog({
        // close confirm dialog
        ...confirmDialog,
        isOpen: false,
      });
      closeCreateSkillCentreDialog();
      setActionWatcher(false)
      // set is loading to true
      // fetch new data
    }
  }, [makingRequest]);

  useEffect(() => {
    if (fetchingDataGeneral === true) {
      fireFetchAllSkillsCentresAPI();
    }
  }, [fetchingDataGeneral]);

  useEffect(() => {
    if (showPrintPreview && skillCenterSelectFetched.length > 0) {
      clearMsg("");
      printIdCardArea();
    } else if (showPrintPreview && skillCenterSelectFetched.length < 0) {
      infoMsg("Loading the print preview window...");
    }
  }, [showPrintPreview, skillCenterSelectFetched]);

  useEffect(() => {
    if (isFetched && showPrintPreview) {
      setShowPrintPreview(false);
      dispatch(emptySkillCenterSelect());
    }
  }, [isFetched, showPrintPreview, dispatch]);

  // constants
  const cards = [
    {
      title: "Centres",
      value: dashboardValues.allCentres,
      icon: "null",
      bgColor: "#C8E7FD",
      iconColor: "#0095FF",
    },
    {
      title: "Active Centres",
      value: dashboardValues.activeCentres,
      icon: "null",
      bgColor: "#CBE1D7",
      iconColor: "#016C34",
    },
    {
      title: "Inactive Centres",
      value: dashboardValues.inactiveCentres,
      icon: "null",
      bgColor: "#FFE2E5",
      iconColor: "#DC2626",
    },
  ];

  const columns = [
    {
      name: "Name",
      label: "name",
      options: {
        setCellProps: () => ({ style: { padding:'20px', maxWidth: "150px" } }),
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              <span style={{marginLeft:'20px'}}>{column.label}</span>
            </Typography>
          );
        },
      },
    },
    {
      name: "Location",
      label: "location",
      options: {
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value) => {
          return <>{value.stateName}</>;
        },
      },
    },
    {
      name: "Skillset",
      label: "No of Skillset",
      options: {
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value) => {
          // return <>{value.length}</>;
          return (
            <Typography align="right" sx={figureColumnStyle}>{value.length}</Typography>
          )
        },
      },
    },
    {
      name: "Status",
      label: "status",
      options: {
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value) => {
          return value === 1 ? (
            <StatusGenerator statusText="Active" variant="greenFilled" />
          ) : (
            <StatusGenerator statusText="Inactive" variant="redFilled" />
          );
        },
      },
    },
    {
      name: "Actions",
      label: "Actions",
      options: {
        sort: false,
        filterType: false,
        filter: false,
        customHeadLabelRender: ({ index, ...column }) => {
          return (
            <Typography sx={ColumnTextStyle} key={index}>
              {column.label}
            </Typography>
          );
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          const centreName = tableMeta.rowData[0];
          const stateData = tableMeta.rowData[1];
          const skillsData = tableMeta.rowData[2]; // array of objects
          let filteredSkillsData = [];

          skillsData.map((skills) => {
            let skillInfo = {
              label: skills.name,
              value: skills.id,
            };
            filteredSkillsData.push(skillInfo);
          });

          console.log(skillsData, "skillsData");
          // console.log(stateData, "statedata")
          let [centreIsActive, centreId] = value.split(" ");
          centreIsActive = Number.parseInt(centreIsActive); // returns NaN or int

          return (
            <>
              <MyViewIcon
                tip={"View Centre"}
                onClickHandler={() => {
                  // setEditCenterId(centreId);
                  openAcquisitionDialog("View");
                  setNewCentreData({
                    name: centreName,
                    stateId: stateData.stateId,
                    skillIds: skillsData.id,
                  });
                  setDialogStateData({
                    label: stateData.stateName,
                    value: stateData.stateId,
                  });
                  setDialogSkillData(filteredSkillsData);
                }}
              />
              <MyEditIcon
                tip={"Edit Centre"}
                onClickHandler={() => {
                  setEditCenterId(centreId);
                  openAcquisitionDialog("Edit");
                  setNewCentreData({
                    name: centreName,
                    stateId: stateData.stateId,
                    skillIds: skillsData.id,
                  });
                  setDialogStateData({
                    label: stateData.stateName,
                    value: stateData.stateId,
                  });
                  setDialogSkillData(filteredSkillsData);
                }}
              />
              {Number.isNaN(centreIsActive) ? null : centreIsActive === 0 ? (
                <Tooltip title={"Activate Centre"}>
                  <IconButton
                    size="small"
                    onClick={() =>
                      setConfirmDialog({
                        isOpen: true,
                        header: `Activate ${centreName}  Centre`,
                        title: `Are you sure you want to activate ${centreName} centre?`,
                        backgroundColor: colors.successDialogBg,
                        borderSideColor: colors.darkSuccessDialog,
                        color: colors.primaryGreen,
                        subColor: colors.successDialogSubTitle,
                        onConfirm: () => {
                          activateCentre(centreId);
                          dispatch(makeRequest());
                        },
                      })
                    }
                  >
                    <ActivateIcon icon="fluent-mdl2:activate-orders" />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title={"Deactivate Centre"}>
                  <IconButton
                    size="small"
                    onClick={() =>
                      setConfirmDialog({
                        isOpen: true,
                        header: `Deactivate ${centreName}  centre `,
                        title: `Are you sure you want to deactivate ${centreName} centre?`,
                        backgroundColor: colors.errorDialogBg,
                        borderSideColor: colors.darkerErrorDialog,
                        color: colors.darkerErrorDialog,
                        subColor: colors.darkerErrorDialog,
                        onConfirm: () => {
                          deactivateCentre(centreId);
                          dispatch(makeRequest());
                        },
                      })
                    }
                  >
                    <DeactivateIcon icon="fluent-mdl2:deactivate-orders" />
                  </IconButton>
                </Tooltip>
              )}
            </>
          );
        },
      },
    },
  ];

  const options = {
    print: false,
    search: false,
    filter: false,
    count: tablePaginationData.totalCount,
    disableRipple: true,
    elevation: 0,
    filterType: "dropdown",
    fixedHeader: true,
    jumpToPage: true,
    pagination: true,
    page: tablePageData.pageNumber - 1, // starting value: 1-1 => 0
    rowsPerPage: 10,
    rowsPerPageOptions: [],
    responsive: "standard",
    selectableRows: "none",
    serverSide: true,
    onDownload: (buildHead, buildBody, columns, data) => {
      dispatch(exportSkillAcquisition());
      return false;
    },

    customToolbar: () => {
      return (
        <>
          <IconButton onClick={printSkillCenterPdf}>
            {<PrintButtonIcon />}
          </IconButton>
          <FilterButton
            options={filterOption}
            filters={filters}
            onClick={handleFilterClick}
            reset={handleReset}
          />
          <ElevatedGreenButton
            startIcon={<AddOutlinedIcon />}
            onClick={() => openAcquisitionDialog("Create")}
          >
            Add New Centre
          </ElevatedGreenButton>
        </>
      );
    },
    onChangePage: (currentPage) => {
      // current page is the destination page
      // console.log(currentPage, " Destination page");

      setTablePageData({
        ...tablePageData,
        pageNumber: currentPage + 1,
      });
      // console.log(tablePageData);
      dispatch(
        fetchAllSkillCentres({
          PageNumber: currentPage + 1,
          PageSize: tablePageData.pageSize,
          Search: searchText,
          FilterOptions: filterOptions,
        })
      );

      dispatch(makeRequest());
    },
    textLabels: {
      body: {
        noMatch: "Sorry, no matching records found",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
      },
      pagination: {
        next: "Next Page",
        previous: "Previous Page",
        rowsPerPage: "Rows per page:",
        displayRows: "of",
      },
      toolbar: {
        search: "Search",
        downloadCsv: "Download sheet",
        print: "Print page",
        viewColumns: "View columns",
        filterTable: "Filter table",
      },
      filter: {
        all: "All",
        title: "FILTERS",
        reset: "RESET",
      },
      viewColumns: {
        title: "Show Columns",
        titleAria: "Show/Hide Table Columns",
      },
      selectedRows: {
        text: "row(s) selected",
        delete: "Delete",
        deleteAria: "Delete Selected Rows",
      },
    },
  };

  // component render
  return (
    <ThemeProvider theme={poppinsCustomTheme}>
      <Page title="SAED | Skill Acquisition">
        <Container maxWidth="xl">
          <Box sx={{ pb: 2 }}>
            <Typography
              variant="h5"
              style={{ fontWeight: 600, color: "#212B36" }}
            >
              Skills Acquisition Centres
            </Typography>
          </Box>
          <Box sx={{ pb: 2 }}>
            {/* overview cards parent grid */}
            <Grid item xs={12} container spacing={3}>
              {cards.map((card, index) => {
                return (
                  <Grid key={index} item xs={12} sm={6} md>
                    <CardTotalSkills
                      value={card.value}
                      title={card.title}
                      bgColor={card.bgColor}
                      iconColor={card.iconColor}
                      isLoading={fetchingDataGeneral}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Box>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box>
                <Paper
                  sx={{
                    boxShadow: "0 1px 2px 0 rgb(145 158 171 / 24%)",
                    borderRadius: "20px",
                  }}
                >
                  <Card
                    elevation={0}
                    sx={{ padding: "0px !important", borderRadius: "20px" }}
                  >
                    <CardContent sx={{ padding: "0px !important" }}>
                      <ThemeProvider theme={MuiDataTableTheme}>
                        <LoadingOverlay
                          active={fetchingDataGeneral || makingRequest || actionWatcher}
                          styles={{
                            overlay: (base) => ({
                              ...base,
                              background: "rgba(0, 0, 0, 0.15)",
                            }),
                          }}
                          spinner
                          text="Fetching Data for You..."
                        >
                          <MUIDataTable
                            title={
                              <Box
                                display="flex"
                                alignItems="center"
                                gap={5}
                                justifyContent="space-between"
                              >
                                <Typography
                                  sx={{ color: "#05004E", fontWeight: 600 }}
                                >
                                  Skill Acquisition Centre
                                </Typography>
                                <Searchbox
                                  placeholder="Skill Acquisition Centre"
                                  onChange={handleChange}
                                  value={searchText}
                                />
                              </Box>
                            }
                            options={options}
                            components={components}
                            columns={columns}
                            data={centresTableData}
                          />
                        </LoadingOverlay>
                      </ThemeProvider>
                    </CardContent>
                  </Card>
                </Paper>
              </Box>
            </Grid>
          </Grid>
          <div id="printarea" style={{ display: "none" }}>
            <AcquisitionPrintTemplate />
          </div>
        </Container>
        <CreateCentreDialog
          isOpen={acquisitionDialogIsOpen}
          isLoading={makingRequest}
          mode={dialogMode}
          nameHolder={newCentreData.name}
          nameSetter={(event) =>{
            setNewCentreData({ ...newCentreData, name: event.target.value })
            setFormStates({...formStates, nameError:false, nameErrorMsg:""})
          }
          }
          onCloseHandler={closeCreateSkillCentreDialog}
          onPrimButtonClickHandler={
            dialogMode === "Create"
              ? createNewCenter
              : dialogMode === "View"
              ? viewCenter
              : dialogMode === "Edit"
              ? editCenter
              : null
          }
          stateHolder={dialogStateData}
          stateSetter={(newState) => {
            // newState : int
            setDialogStateData(newState);
            setNewCentreData({ ...newCentreData, stateId: newState.value });
            setFormStates({...formStates, stateIdError:false, stateIdErrorMsg:""})
          }}
          skillHolder={dialogSkillData}
          skillSetter={(newState) => {
            console.log(newState, "The new State");
            setDialogSkillData(newState);
            const newArray = [];
            for (let i = 0; i < newState.length; i++) {
              newArray.push(newState[i].value);
              setNewCentreData({
                ...newCentreData,
                skillIds: newArray,
              });
            }
            setFormStates({...formStates, skillIdsError:false, skillIdsErrorMsg:""})
          }}
          states={allStatesNG}
          skills={skillSelect}
          form={formStates}
        />
        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
      </Page>
    </ThemeProvider>
  );
};

export default SkillAcquisitionCentre;